import { is, trim, isNil, includes } from 'ramda';
import * as constants from '../../backend/constants';
import { POI_FIELDS } from '../constants';
import BulkOSMHoursEditor from '../osm-hours-editor/BulkOSMHoursEditor';
import BulkCategoryEditor from './BulkCategoryEditor';
import BulkSecurityEditor from './BulkSecurityEditor';
import BulkTagEditor from './BulkTagEditor';
import BulkTextField from './BulkTextField';

export const changeLabel = (changeType, pluralTargetName) => {
    switch (changeType) {
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE:
            return `Delete ${pluralTargetName}`;
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE:
            return `Replace ${pluralTargetName}`;
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.STATUS_CHANGE:
            return `Replace ${pluralTargetName}`;
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.CATEGORY_CHANGE:
            return `Replace ${pluralTargetName}`;
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.SECURITY_CHANGE:
            return `Replace ${pluralTargetName}`;
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.ARRAY_ADD:
            return `Add ${pluralTargetName}`;
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.ARRAY_REMOVE:
            return `Remove ${pluralTargetName}`;
        default:
            return '---';
    }
};

export const BULK_FIELDS = {
    [POI_FIELDS.NAME]: {
        title: 'POI Name',
        field: POI_FIELDS.NAME,
        subtitle: 'Replace the existing POI Names with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter name...',
    },
    [POI_FIELDS.CATEGORY]: {
        title: 'Category & Icon',
        field: POI_FIELDS.CATEGORY,
        subtitle: 'Replace the existing Categories & Icon Information with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.CATEGORY_CHANGE,
        ],
        editor: BulkCategoryEditor,
        placeholder: 'Select category...',
    },
    [POI_FIELDS.GATE]: {
        title: 'Nearby Location',
        subtitle: 'Replace the existing Level information with the following',
        field: POI_FIELDS.GATE,
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter Nearby Location...',
    },
    [POI_FIELDS.URL]: {
        title: 'Website',
        field: POI_FIELDS.URL,
        subtitle: 'Replace the existing Website information with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'http://www.examplesite.com',
    },
    [POI_FIELDS.SECURITY]: {
        title: 'Security Restriction',
        field: POI_FIELDS.SECURITY,
        subtitle: 'This will affect every POI selected',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.SECURITY_CHANGE,
        ],
        editor: BulkSecurityEditor,
    },
    [POI_FIELDS.DESCRIPTION]: {
        title: 'Description',
        field: POI_FIELDS.DESCRIPTION,
        subtitle: 'Replace the existing Description information with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter a description...',
    },
    [POI_FIELDS.PHONE]: {
        title: 'Phone Number',
        field: POI_FIELDS.PHONE,
        subtitle: 'Replace the existing Phone Number information with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: '+1 (555) 555-5555',
    },
    [POI_FIELDS.RAW_HOURS]: {
        title: 'Operating Hours',
        pluralTitle: 'Operating Hours',
        field: POI_FIELDS.RAW_HOURS,
        subtitle: 'Replace the existing Opening Hours information with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkOSMHoursEditor,
    },
    [POI_FIELDS.ADDITIONAL_ATTRIBUTES]: {
        title: 'Additional Attributes',
        pluralTitle: 'Additional Attributes',
        field: POI_FIELDS.ADDITIONAL_ATTRIBUTES,
        subtitle: 'Replace the existing Additional Attributes information with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter some attributes...',
    },
    [POI_FIELDS.DISPLAY_TAGS]: {
        title: 'Visible Tags',
        pluralTitle: 'Visible Tags',
        field: POI_FIELDS.DISPLAY_TAGS,
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.ARRAY_ADD,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.ARRAY_REMOVE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTagEditor,
        defaultValue: [],
    },
    [POI_FIELDS.TAGS]: {
        title: 'Hidden Tags',
        pluralTitle: 'Hidden Tags',
        field: POI_FIELDS.TAGS,
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.ARRAY_ADD,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.ARRAY_REMOVE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTagEditor,
        defaultValue: [],
    },
    [POI_FIELDS.IMAGE]: {
        title: 'Primary Photo',
        field: POI_FIELDS.IMAGE,
        subtitle: 'Replace the existing Primary Photo with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter file name...',
    },
    [POI_FIELDS.ADDITIONAL_IMAGES]: {
        title: 'Additional Photos',
        field: POI_FIELDS.ADDITIONAL_IMAGES,
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter file name(s)...',
    },
    [POI_FIELDS.LOGO]: {
        title: 'Logo',
        field: POI_FIELDS.LOGO,
        subtitle: 'Replace the existing Logo with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter the file name(s)...',
    },
    [POI_FIELDS.AIRLINE_CODE]: {
        title: 'Airline Code',
        field: POI_FIELDS.AIRLINE_CODE,
        subtitle: 'Replace the existing Airline Code with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter Airline Code...',
    },
    [POI_FIELDS.ATTRIBUTES]: {
        title: 'Attributes',
        pluralTitle: 'Attributes',
        field: POI_FIELDS.ATTRIBUTES,
        subtitle: 'Replace the existing Attributes with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter Attributes...',
    },
    [POI_FIELDS.CATEGORY_SEARCH]: {
        title: 'Category Search',
        pluralTitle: 'Category Searches',
        field: POI_FIELDS.CATEGORY_SEARCH,
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter Category Searches...',
    },
    [POI_FIELDS.ROTATION_PROPERTIES]: {
        title: 'Map Rotation',
        field: POI_FIELDS.ROTATION_PROPERTIES,
        subtitle: 'Replace the existing Map Rotation value with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter Rotation value...',
    },
    [POI_FIELDS.DISPLAY_PROPERTIES]: {
        title: 'Display Properties',
        pluralTitle: 'Display Properties',
        field: POI_FIELDS.DISPLAY_PROPERTIES,
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter Display Properties...',
    },
    [POI_FIELDS.NO_DIRECTIONS]: {
        title: 'Directions',
        pluralTitle: 'Directions',
        field: POI_FIELDS.NO_DIRECTIONS,
        subtitle: 'Replace the existing Directions information with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter Directions value...',
    },
    [POI_FIELDS.URL_DISPLAY]: {
        title: 'Url Display',
        field: POI_FIELDS.URL_DISPLAY,
        subtitle: 'Replace the existing URL Display information with the following',
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
        placeholder: 'Enter URL Display value...',
    },
    [POI_FIELDS.CUSTOM_SEARCHES]: {
        title: 'Custom Searches',
        pluralTitle: 'Custom Searches',
        field: POI_FIELDS.CUSTOM_SEARCHES,
        changeTypes: [
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE,
            constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE,
        ],
        editor: BulkTextField,
    },
};

export const TABS = [
    {
        title: 'DISPLAY',
        fields: [POI_FIELDS.CATEGORY],
    },
    {
        title: 'INFO',
        fields: [
            POI_FIELDS.NAME,
            POI_FIELDS.GATE,
            POI_FIELDS.SECURITY,
            POI_FIELDS.DESCRIPTION,
            POI_FIELDS.URL,
            POI_FIELDS.PHONE,
            POI_FIELDS.RAW_HOURS,
            POI_FIELDS.ADDITIONAL_ATTRIBUTES,
        ],
    },
    {
        title: 'TAGS',
        fields: [POI_FIELDS.DISPLAY_TAGS, POI_FIELDS.TAGS],
    },
    {
        title: 'INTERNAL',
        fields: [
            POI_FIELDS.AIRLINE_CODE,
            POI_FIELDS.ATTRIBUTES,
            POI_FIELDS.CATEGORY_SEARCH,
            POI_FIELDS.ROTATION_PROPERTIES,
            POI_FIELDS.DISPLAY_PROPERTIES,
            POI_FIELDS.NO_DIRECTIONS,
            POI_FIELDS.URL_DISPLAY,
            POI_FIELDS.CUSTOM_SEARCHES,
        ],
    },
];

// {
//     title: 'IMAGES',
//     fields: [POI_FIELDS.IMAGE, POI_FIELDS.ADDITIONAL_IMAGES, POI_FIELDS.LOGO],
// },

export const makeChangeTypeOptions = fieldName => {
    const { title, changeTypes, pluralTitle } = BULK_FIELDS[fieldName];
    const options = changeTypes.map(changeType => ({
        label: changeLabel(changeType, pluralTitle || `${title}s`),
        value: changeType,
    }));
    return options;
};

export const isValidChange = (changeType, value, subValue) => {
    switch (changeType) {
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.NONE:
            return false;
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.DELETE:
            return true;
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE: {
            if (is(String, value)) {
                return trim(value).length > 0;
            }
            if (is(Array, value)) {
                return value.length > 0;
            }
            break;
        }
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.CATEGORY_CHANGE:
            return !isNil(value) && value !== '' && !isNil(subValue) && subValue !== '';
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.SECURITY_CHANGE:
            return includes(value, ['Inside', 'Outside']);
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.ARRAY_REMOVE:
        case constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.ARRAY_ADD:
            return is(Array, value) && value.length > 0;
        default:
            return false;
    }
};
